import { render } from "./DashboardOfferFooter.vue?vue&type=template&id=753efc02&scoped=true"
import script from "./DashboardOfferFooter.vue?vue&type=script&lang=ts"
export * from "./DashboardOfferFooter.vue?vue&type=script&lang=ts"

import "./DashboardOfferFooter.vue?vue&type=style&index=0&id=753efc02&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-753efc02"

export default script